/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  SIGN_IN_USER: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.trag.signIn.user.getSignInType',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_EMAIL_DETAILS' },
      },
    },
    GET_EMAIL_DETAILS: {
      invoke: {
        id: 'getEmailDetails',
        src: 'getEmailDetails',
        onDone: {
          target: 'GET_EMAIL_DETAILS_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'GET_EMAIL_DETAILS_FAILURE',
          actions: ['failureAction'],
        },
      },
    },
    GET_EMAIL_DETAILS_SUCCESS: {
      type: 'final',
    },
    GET_EMAIL_DETAILS_FAILURE: {
      on: {
        START: { target: 'GET_EMAIL_DETAILS' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
